<template>
  <div class="account-select">
    <v-select
      v-model="data[field]"
      class="account-select__control"
      :reduce="(account) => account.id"
      label="name"
      :options="accounts"
      :clearable="false"
      :searchable="true"
      :placeholder="placeholderText"
    >
      <template slot="selected-option" slot-scope="option">
        <div class="account-select__picked">
          <span class="account-select__picked-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="2" />
              <line x1="2" y1="10" x2="22" y2="10" />
            </svg>
          </span>
          <span class="account-select__picked-text">{{ option.name }}</span>
        </div>
      </template>
      <template slot="option" slot-scope="option">
        <div class="account-select__row">
          <span class="account-select__row-marker" aria-hidden="true" />
          <span class="account-select__row-label">{{ option.name }}</span>
        </div>
      </template>
    </v-select>
  </div>
</template>
<script>
export default {
  props: {
    data: { type: Object, required: true },
    field: { type: String, required: true },
    accounts: { type: Array, required: true },
    /** 'withdraw' uses withdrawal copy for placeholder */
    variant: { type: String, default: '' },
  },
  computed: {
    placeholderText() {
      const isWithdraw = this.variant === 'withdraw';
      if (!this.$store) {
        return isWithdraw ? 'Choose withdrawal method' : 'Choose payment method';
      }
      if (this.$store.state.language === 'en') {
        return isWithdraw
          ? 'Choose withdrawal method'
          : 'Choose payment method';
      }
      return isWithdraw
        ? 'ငွေထုတ်ယူမည့် နည်းလမ်း ရွေးချယ်ပါ'
        : 'ငွေပေးချေမှုနည်းလမ်း ရွေးချယ်ပါ';
    },
  },
};
</script>
<style scoped>
.account-select {
  position: relative;
}

.account-select__control {
  margin: 0;
}

/* Gradient ring + inset highlight — distinct from flat text inputs */
.account-select >>> .vs__dropdown-toggle {
  align-items: center;
  background: linear-gradient(165deg, #232833 0%, #1a1e26 100%) !important;
  border: none !important;
  border-radius: 14px !important;
  box-shadow:
    0 0 0 1px rgba(106, 159, 255, 0.28),
    0 4px 18px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;
  cursor: pointer;
  min-height: 3.35rem;
  padding: 0.35rem 0.5rem 0.35rem 0.85rem !important;
  transition: box-shadow 0.2s ease, background 0.2s ease;
}

.account-select >>> .vs--open .vs__dropdown-toggle {
  box-shadow:
    0 0 0 2px rgba(92, 152, 255, 0.55),
    0 6px 22px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.06) !important;
}

.account-select >>> .vs__selected-options {
  align-items: center;
  display: flex;
  flex: 1;
  flex-wrap: nowrap;
  min-width: 0;
  padding: 0.15rem 0;
}

.account-select >>> .vs__selected {
  margin: 0;
  max-width: 100%;
  padding: 0 !important;
}

.account-select >>> .vs__search {
  margin: 0;
  padding: 0 !important;
}

.account-select >>> .vs__search input {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #f0f2f5 !important;
  font-size: 1rem !important;
  line-height: 1.4 !important;
  margin: 0 !important;
  min-height: 2.5rem;
  padding: 0.35rem 0 !important;
  width: 100%;
}

.account-select >>> .vs__search input::placeholder {
  color: #8b95a8 !important;
  font-weight: 500;
  opacity: 1;
}

.account-select__picked {
  align-items: center;
  display: flex;
  gap: 0.65rem;
  min-width: 0;
  width: 100%;
}

.account-select__picked-icon {
  align-items: center;
  background: rgba(92, 152, 255, 0.14);
  border-radius: 10px;
  color: #8ab4ff;
  display: flex;
  flex-shrink: 0;
  height: 2.35rem;
  justify-content: center;
  width: 2.35rem;
}

.account-select__picked-text {
  color: #f0f2f5;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-select >>> .vs__actions {
  align-items: center;
  display: flex;
  padding: 0 0.35rem 0 0.5rem;
}

.account-select >>> .vs__open-indicator {
  transform-origin: center;
  transition: transform 0.22s ease;
}

.account-select >>> .vs__open-indicator path {
  fill: #7aa3ff !important;
}

.account-select >>> .vs--open .vs__open-indicator {
  transform: rotate(180deg);
}

.account-select >>> .vs--open .vs__open-indicator path {
  fill: #b8d0ff !important;
}

/* Dropdown */
.account-select >>> .vs__dropdown-menu {
  background: #1e222b !important;
  border: 1px solid rgba(106, 159, 255, 0.22) !important;
  border-radius: 14px !important;
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(255, 255, 255, 0.04) !important;
  margin-top: 6px !important;
  max-height: 280px !important;
  overflow: hidden;
  padding: 0.35rem !important;
  z-index: 4000 !important;
}

.account-select >>> .vs__dropdown-option {
  border-radius: 10px !important;
  color: #e8eaef !important;
  font-size: 0.95rem !important;
  margin: 2px 0 !important;
  padding: 0 !important;
}

.account-select >>> .vs__dropdown-option--highlight {
  background: rgba(92, 152, 255, 0.18) !important;
}

.account-select >>> .vs__dropdown-option--selected {
  background: rgba(92, 152, 255, 0.12) !important;
  font-weight: 600;
}

.account-select__row {
  align-items: center;
  display: flex;
  gap: 0.65rem;
  padding: 0.75rem 0.85rem;
}

.account-select__row-marker {
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%);
  border-radius: 4px;
  flex-shrink: 0;
  height: 1.85rem;
  width: 4px;
}

.account-select__row-label {
  flex: 1;
  min-width: 0;
}
</style>
